<dx-polar-chart
  class="matrix-chart"
  [dataSource]="data"
  [useSpiderWeb]="true"
>
  <dxi-series
    type="line"
    name="User"
    argumentField="categoryName"
    valueField="countOfCompletedEventsForUser"
  ></dxi-series>

  <dxo-argument-axis [categories]="categoryNames">
    <dxo-label
      [visible]="true"
      [overlappingBehavior]="'none'"
      [customizeText]="customizeLabel"
    ></dxo-label>
  </dxo-argument-axis>

  <dxo-legend
    [visible]="false"
  ></dxo-legend>
</dx-polar-chart>